import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MANAGE_REPORT_MODAL';

export const {action: showNew} = createAction(
    `${domain}/SHOW_NEW`,
    (institutionId: string, childId: string | undefined) => ({institutionId, childId}),
);

export const {
    action: fetchChildren,
    success: fetchChildrenSuccess,
    failed: fetchChildrenFailed,
} = createAction(`${domain}/FETCH_CHILDREN`, (institutionId: string) => ({institutionId}));

export const {action: showExisting} = createAction(
    `${domain}/SHOW_EXISTING`,
    (institutionId: string, reportId: string) => ({institutionId, reportId}),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
